
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.784 10.426c-1.349.21-2.493-.952-2.287-2.32.13-.852.816-1.548 1.656-1.679 1.348-.21 2.492.952 2.286 2.32-.129.852-.815 1.548-1.655 1.679M21.679 1a.192.192 0 01.194.162c.178 1.004.852 6.545-4.387 12.997a11.423 11.423 0 01-1.79 1.755.188.188 0 00-.07.187c.187.946.417 2.847-.442 3.942-1.773 2.26-4.356 2.827-5.181 2.955a.209.209 0 01-.237-.233s.352-3.46.425-4.202a.108.108 0 00-.122-.12c-.406.057-1.024.132-1.195.091-.26-.062-2.2-1.696-2.303-1.947-.068-.165-.087-.785-.092-1.184a.098.098 0 00-.123-.094l-4.129 1.104A.18.18 0 012 16.24c-.007-.803.125-3.529 2.084-5.685.96-1.057 2.92-1.092 3.844-1.044a.184.184 0 00.172-.098c.434-.781.97-1.547 1.634-2.244C15.232 1.403 20.68 1.021 21.68 1zM4.576 17.824c.58-.702 1.443-.973 1.564-.667.2.503-.396.417-.637 1.59-.186.908.12 1.319.115 1.334.012-.006.456.24 1.312-.086 1.106-.422.947-.993 1.467-.87.317.076.185.982-.409 1.67-.356.414-.874.741-1.432.886-1.239.322-2.383.13-2.383.13s-.362-1.125-.239-2.415a2.962 2.962 0 01.642-1.572z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    